<script>
import  { Sketch }  from '@ckpack/vue-color';
export default {
    components:{ Sketch },
    props: ['color', 'text', 'isOutline', 'hideAll', ],
    data(){
      return {
          showPicker: false,
          sketchColor: {},
          instanceId: `cp_${Math.random().toString(36).slice(2)}`
      }
    },
    methods: {
       handleGlobalClick(e) {
        if (!this.showPicker) return;

        // Klickade jag inne i MIN instans?
        const insideMe = e.target.closest(
          `.color-picker-root[data-cpid="${this.instanceId}"]`
        );

        if (!insideMe) {
          this.showPicker = false;
        }
      }
    },
    mounted() {
      document.addEventListener('click', this.handleGlobalClick);
    },
    beforeUnmount() {
      document.removeEventListener('click', this.handleGlobalClick);
    },
    watch:
    {
      sketchColor(newvalue){
        if(typeof newvalue === 'object') {
          console.log(newvalue);
          if(this.isOutline)
          {
            this.color.outline = newvalue.hex8 == "#00000000" ? null : newvalue.hex;     
          } 
          else 
          {
            this.color.color = newvalue.hex;
          }
        }
      }
    }
}
</script>
<template>
  <div class="color-picker-root" :data-cpid="instanceId">
    <div class="ColorPickerPreview" :style="{ 'background-color': isOutline ? color.outline : color.color }"  @click="showPicker = !showPicker">
      <span>{{ text }}</span>
      <i class="fa-solid fa-pencil"></i>
    </div>
    <div v-if="showPicker" class="ColorPicker-picker">
        <Sketch v-model="sketchColor"></Sketch>
        <button class="btn float-right" @click="showPicker = false">Klar</button>
    </div>
  </div>
</template>

<style scoped>
  .ColorPickerPreview
  {
    border-radius: 2px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    padding: 6px;
  }
  
  .ColorPickerPreview span
  {
    color: white;
    opacity: 0.9;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
  }
  
  .ColorPickerPreview i
  {
    float: right;
    margin: 4px;
    opacity: 0.3;
    color: black;
  }



  .ColorPicker-picker
  {
    background-color: white;
    border-radius: 4px;
    border: 1px solid black;
    width: 220px;
    padding: 5px;
    overflow: auto;
    position: absolute;
    z-index: 200;
  }
  .vc-sketch
  {
    border-radius: 0px !important;
    box-shadow: none !important;
  }
</style>